import React from "react";
import { BrowserRouter as Router, Routes, Route } from "react-router-dom";
import ScrollToTop from "./components/ScrollToTop"; // 👈 add this

import Home from "./pages/Home";
import ObsGynae from "./components/Homesections/ObsGynae";
import ServiceDetail from "./components/Homesections/serviceDetailsData";
import FemaleInfertilityDetail from "./components/Homesections/FemaleInfertilityDetail";
import Obs from "./pages/obs-gynae";
import FemaleInfertility from "./components/FemaleInfertilitycomponent";
import TestimonialSection from "./pages/testimoniyal";
import About from "./pages/about";
import ContactUs from "./pages/contactus";
import BlogList from "./pages/Blog/Blogs/Blogs";
import BlogDetail from "./pages/Blog/BlogDetails/BlogDetails";

function App() {
  return (
    <Router>
      <ScrollToTop /> {/* 👈 yaha add karo */}
      
      <Routes>
        {/* Main Pages */}
        <Route path="/" element={<Home />} />

        {/* OBS & GYNAE */}
        <Route path="/obs" element={<ObsGynae />} />
        <Route path="/obs-gynae/:parentSlug/:slug" element={<ServiceDetail />} />

        <Route
          path="/services/:slug"
          element={<FemaleInfertilityDetail />}
        />

        <Route path="/about-us" element={<About />} />
        <Route path="/obs-gynae" element={<Obs />} />
        <Route path="/services" element={<FemaleInfertility />} />
        <Route path="/testimonial" element={<TestimonialSection />} />
        <Route path="/contact-us" element={<ContactUs />} />
        <Route path="/blogs" element={<BlogList />} />
        <Route path="/blogs/:slug" element={<BlogDetail />} />
      </Routes>
    </Router>
  );
}

export default App;